module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'au12jjja',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
